import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_el_avatar = _resolveComponent("el-avatar")!

  return (_openBlock(), _createElementBlock("div", null, [
    _createVNode(_component_el_avatar, {
      shape: "shape",
      size: _ctx.size
    }, {
      default: _withCtx(() => [
        _createTextVNode(_toDisplayString(_ctx.firstName?.[0].toUpperCase() + _ctx.lastName?.[0].toUpperCase()), 1)
      ]),
      _: 1
    }, 8, ["size"])
  ]))
}